import * as React from "react";
import { FreeHtml } from "sb-resp-ui";
import Debounce from "debounce-decorator";

export class RibbonMessage extends React.Component<{
    className: string,
    message: string,
    handler: Function,
    resizeHandler: Function
}, {}> {
    boundOwnResizeHandler: EventListener;
    ref: React.RefObject<HTMLDivElement>;
    constructor(props) {
        super(props);

        this.ref = React.createRef();
        this.boundOwnResizeHandler = this.ownResizeHandler.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.boundOwnResizeHandler);
        this.ownResizeHandler();
    }

    /* istanbul ignore next */
    componentDidUpdate(prevProps) {

        if (this.props.message !== prevProps.message) {
            this.ownResizeHandler();
        }
    }

    /* istanbul ignore next */
    componentWillUnmount() {
        window.removeEventListener("resize", this.boundOwnResizeHandler);
    }

    @Debounce(50)
    ownResizeHandler() {
        this.ref.current && this.ref.current.firstElementChild && this.props.resizeHandler(this.ref.current.clientWidth, this.ref.current.firstElementChild.scrollWidth);
    }

    /* istanbul ignore next */
    render() {
        return (
            <div ref={this.ref} className={this.props.className} onClick={(e) => this.props.handler(e)} >
                <FreeHtml html={this.props.message} />
            </div>
        )
    }
}
